import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import ProfileSetupWizard from './ProfileSetupWizard';
import { BEHAVIOURAL_QUESTIONS } from '@/utils/behavioural';

const PROFILE_KEYS = ['role', 'organisation', 'background', 'sector', 'country', 'location', 'region', 'forum_topics_of_interest', ...BEHAVIOURAL_QUESTIONS.map(q => q.key)];

const call = async (url, opts) => {
  const r = await fetch(url, { credentials: 'include', ...opts });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw new Error(typeof e.detail === 'string' ? e.detail : 'Something went wrong');
  }
  return r.json();
};

// Locked first-login setup for members created via Google/LinkedIn.
export default function ProfileSetupGate({ user, onDone }) {
  const [status, setStatus] = useState(null);
  useEffect(() => { call('/api/members/me/setup-status').then(setStatus).catch(() => setStatus({ missing: [] })); }, []);
  if (!status) return null;

  const p = user.profile || {};
  const initial = { name: user.name || '', email: user.email || '', ...Object.fromEntries(PROFILE_KEYS.map(k => [k, p[k] || (k === 'forum_topics_of_interest' ? [] : '')])) };
  const hasPhoto = !status.missing.includes('Headshot');

  const submit = async (v, photo) => {
    try {
      if (photo) {
        const fd = new FormData();
        fd.append('file', photo, 'headshot.jpg');
        await call('/api/members/me/upload-photo', { method: 'POST', body: fd });
      }
      await call('/api/members/me', {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: v.name.trim(), profile: Object.fromEntries(PROFILE_KEYS.map(k => [k, typeof v[k] === 'string' ? v[k].trim() : v[k]])) }),
      });
      await call('/api/members/me/complete-setup', { method: 'POST' });
      const fresh = await call('/api/auth/session');
      const s = JSON.stringify(fresh);
      sessionStorage.setItem('sll_user', s);
      localStorage.setItem('sll_user', s);
      toast.success('Profile complete — welcome to BriteHub!');
      onDone(fresh);
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-start sm:items-center justify-center p-4 py-10" data-testid="profile-setup-gate">
      <div className="w-full max-w-lg bg-white rounded-2xl border border-slate-100 shadow-xl p-6 sm:p-8">
        <h1 className="text-2xl font-bold font-heading text-brand-navy">Complete your profile</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">A few details so the community knows who you are. This takes about 2 minutes.</p>
        <ProfileSetupWizard mode="complete" initial={initial}
          initialPhotoUrl={hasPhoto ? `/api/members/${user.user_id}/avatar` : null}
          onSubmit={submit} submitLabel="Finish & enter BriteHub" />
      </div>
    </div>
  );
}
